import { IAutoCompleteSettings } from './auto-complete.module';
export const AUTO_COMPLETE_DEFAULT_SETTINGS: IAutoCompleteSettings = {
  isSuggestion: true,
  isForceVisible: true,
  needSelection: false,
  isDynamicData: false,
  selectionOnclick: false,
  isGroup: false,
  placeholder: 'Press <space> for all',
  isClearAll: false,
  searchBy: ['name', 'prefix'],
  searchFn: 'startsWith',
  disabled: false,
  isFocusFirstElement: false,
  keyboardPosition: 'auto',
  position: 'bottom',
  autoSelectKey: 'prefix',
  maxHeight: 260,
};
